import React from 'react'

export default function FaceFeature({ scaleX, fill, outline }) {
  return (
    <g transform={`scale(${scaleX},1)`} fill="none">
      <path
        d="M7.57998 48.7601C7.57998 48.7601 6.60998 41.69 8.07998 36.71C9.72998 31.1 13.03 28.78 12.87 19.87C12.87 19.87 16.5 22.51 25.42 20.86C34.34 19.21 39.13 18.05 44.25 18.71C44.25 18.71 48.87 21.35 51.35 24.32C51.35 24.32 50.85 27.71 52.51 33.98C53.2 36.61 54.57 42.0701 54.16 48.7601C54.16 48.7601 54.74 42.73 56.47 40.83C57.22 40.01 57.79 39.3401 59.61 39.7601C59.61 39.7601 60.93 25.9701 57.3 17.8801C53.67 9.79005 45.08 1.53003 29.39 1.86004C13.7 2.19004 10.07 12.7601 10.07 12.7601C10.07 12.7601 4.45997 14.74 2.63997 23C0.819975 31.26 2.71998 39.68 2.71998 39.68C2.71998 39.68 4.16998 39.3801 5.85998 41.6601C7.48998 43.8901 7.57998 48.7601 7.57998 48.7601Z"
        fill={fill}
        stroke={outline}
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinejoin="round"
      />
      <path
        d="M50.3499 12.92C47.6999 12.42 45.05 12.6699 42.72 13.5699C41.56 14.0299 40.5 14.67 39.41 15.42L36.07 17.64C34.92 18.36 33.72 19.02 32.48 19.63C31.21 20.17 29.94 20.73 28.59 21.03C25.92 21.74 23.1 21.88 20.45 21.34C23.14 21.05 25.7 20.4699 28.11 19.5499C30.53 18.6299 32.79 17.38 35 15.95C37.25 14.62 39.4 12.88 42.23 12.09C44.98 11.36 47.9599 11.63 50.3499 12.92Z"
        fill={outline}
      />
      <path
        d="M55.9601 19.2C54.2201 19.02 52.5001 18.8901 50.7801 18.7501C49.0601 18.6201 47.3401 18.51 45.6201 18.47C43.9001 18.41 42.1901 18.4401 40.4701 18.5001C38.7601 18.6101 37.0501 18.7701 35.3201 19.0401C36.9401 18.3901 38.6601 17.96 40.4001 17.72C42.1401 17.5 43.9001 17.43 45.6501 17.47C49.1501 17.6 52.6401 18.1 55.9601 19.2Z"
        fill={outline}
      />
      <path
        d="M32.6799 12.59C31.4799 13.89 30.0599 14.99 28.5199 15.9C26.9899 16.82 25.3199 17.53 23.5799 18C21.8299 18.46 19.9899 18.58 18.1999 18.37C16.3899 18.2 14.6999 17.4399 13.1899 16.5499C13.6199 16.6699 14.0399 16.7999 14.4499 16.9399L15.0699 17.14L15.7099 17.25C16.1399 17.33 16.5499 17.43 16.9799 17.49L18.2599 17.59C19.9599 17.63 21.6699 17.48 23.3299 17.03C24.9899 16.6 26.5899 15.97 28.1499 15.22C29.6999 14.45 31.2199 13.6 32.6799 12.59Z"
        fill={outline}
      />
      <path
        d="M48.45 21.01C49.38 21.41 50.22 21.99 51.01 22.62C51.8 23.25 52.52 23.96 53.18 24.73C54.49 26.26 55.59 27.9999 56.21 29.9299C55.53 29.1699 54.94 28.39 54.31 27.63C53.69 26.87 53.06 26.12 52.42 25.38C51.79 24.63 51.13 23.9199 50.47 23.1899L48.45 21.01Z"
        fill={outline}
      />
      <path
        d="M12.28 19.4399C12.66 20.5499 12.77 21.7499 12.72 22.9399C12.66 24.1299 12.37 25.3299 11.84 26.4299C11.31 27.5399 10.43 28.49 9.40001 29.13C8.38001 29.83 7.16001 30.07 6.01001 30.17C7.08001 29.67 8.12001 29.24 8.94001 28.5C9.77001 27.8 10.49 26.97 10.94 25.98C11.91 24.04 12.2 21.7699 12.28 19.4399Z"
        fill={outline}
      />
    </g>
  )
}
